export const styles = theme => ({
    title: {
        "& h2": {
            margin: "1.5rem 0",
        },
    },
    token: {
        wordBreak: "break-all" as const,
    }
})